import React from "react";

import { CocktailGridBlock as Value } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { ANTONIO_URL, TYPEKIT_URL } from "../../utils/groups";

import hh from "../../styles/happy-hour.module.scss";
import styles from "./index.module.scss";

interface Props {
    value: Value;
}

const LAYOUTS = {
    "columns": styles.columns,
    "grid-5": styles.gridFive,
    "grid-2": styles.gridTwo,
};

export const CocktailGridBlock = (props: Props) => {
    const value = props.value;
    if (!value.heading) {
        return null;
    }
    const layout = value.layout ?? "grid-5";
    const items = (value.items ?? []).filter((item) => item.name);
    return (
        <section
            className={concatClassNames([
                hh.tokens,
                value.background === "cream" ? hh.cream : hh.page,
                styles.section,
                layout === "columns" ? styles.featured : undefined,
            ])}
        >
            <link rel="stylesheet" href={TYPEKIT_URL} precedence="default" />
            <link rel="stylesheet" href={ANTONIO_URL} precedence="default" />
            <div className={hh.container}>
                {value.eyebrow && (
                    <p
                        className={concatClassNames([
                            hh.eyebrow,
                            styles.eyebrow,
                        ])}
                    >
                        {value.eyebrow}
                    </p>
                )}
                <h2
                    className={concatClassNames([
                        hh.display,
                        styles.heading,
                        value.eyebrow ? styles.headingAfterEyebrow : undefined,
                    ])}
                >
                    {value.heading}
                </h2>
                {value.image && (
                    <img
                        className={styles.banner}
                        src={value.image.url}
                        alt={value.image.default_alt_text}
                        width={value.image.width}
                        height={value.image.height}
                        loading="lazy"
                    />
                )}
                {value.subheading && (
                    <p
                        className={concatClassNames([
                            hh.eyebrow,
                            styles.subheading,
                        ])}
                    >
                        {value.subheading}
                    </p>
                )}
                {items.length > 0 && (
                    <div
                        className={concatClassNames([
                            styles.items,
                            LAYOUTS[layout],
                        ])}
                    >
                        {items.map((item, index) => (
                            <article key={index} className={styles.item}>
                                {/* Decorative, as on the Happy Hour site: the
                                    cocktail's name follows as its heading. */}
                                {item.image && (
                                    <img
                                        className={styles.itemPhoto}
                                        src={item.image.url}
                                        alt=""
                                        width={item.image.width}
                                        height={item.image.height}
                                        loading="lazy"
                                    />
                                )}
                                <h3
                                    className={concatClassNames([
                                        hh.display,
                                        styles.itemName,
                                    ])}
                                >
                                    {item.name}
                                </h3>
                                {item.description && (
                                    <p className={styles.itemCopy}>
                                        {item.description}
                                    </p>
                                )}
                            </article>
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
};
